import { render, staticRenderFns } from "./AppUserRegister.vue?vue&type=template&id=b5857b80&"
import script from "./AppUserRegister.vue?vue&type=script&lang=js&"
export * from "./AppUserRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports